import React from 'react';
import { Chip } from '@mui/material';
import { DataTypeProvider } from '@devexpress/dx-react-grid';

const OtherAccessoriesFormatter = ({ row }) => {
  return (
    <>
      {row.other_accessories && row.other_accessories.includes('\n') ? (
        <ul style={{ margin: 0, paddingLeft: 18 }}>
          {row.other_accessories.split(/\r?\n/).filter(Boolean).map((acc, i) => (
            <li key={i} style={{ color: '#222', fontSize: 15 }}>{acc.trim()}</li>
          ))}
        </ul>
      ) : (
        row.other_accessories
      )}      
    </>
  );
};
const OtherAccessoriesTypeProvider = props => <DataTypeProvider formatterComponent={OtherAccessoriesFormatter} {...props} />

export default OtherAccessoriesTypeProvider;
